import { Link } from 'react-router-dom';

interface ClusterCard {
  title: string;
  description: string;
  to?: string;
  available: boolean;
}

const clusterCards: ClusterCard[] = [
  {
    title: 'Обучение персонала',
    description: 'Как организовать системное обучение сотрудников под задачи компании и какие задачи оно решает.',
    to: '/enciklopediya-korporativnogo-obucheniya/obuchenie-personala',
    available: true,
  },
  {
    title: 'Развитие Soft Skills',
    description: 'Коммуникация, эмоциональный интеллект, командное взаимодействие и другие гибкие навыки сотрудников.',
    to: '/enciklopediya-korporativnogo-obucheniya/razvitie-soft-skills',
    available: true,
  },
  {
    title: 'Адаптация сотрудников',
    description: 'Как быстрее вводить новых сотрудников в рабочую роль и выводить их на самостоятельную работу.',
    to: '/enciklopediya-korporativnogo-obucheniya/adaptaciya-sotrudnikov',
    available: true,
  },
  {
    title: 'Оценка и развитие сотрудников',
    description: 'Оценка компетенций, выявление зон развития и кадровый резерв: как превратить результаты оценки в план развития.',
    to: '/razvitie-personala/otsenka-i-razvitie-sotrudnikov',
    available: true,
  },
  {
    title: 'Наставничество и развитие сотрудников',
    description: 'Передача опыта, развитие самостоятельности и подготовка сотрудников к новым ролям внутри компании.',
    to: '/menedzhment-i-liderstvo/nastavnichestvo-i-razvitie-sotrudnikov',
    available: true,
  },
  {
    title: 'Оценка эффективности обучения персонала',
    description: 'Как понять, изменились ли знания, навыки и поведение сотрудников после обучения.',
    to: '/enciklopediya-korporativnogo-obucheniya/ocenka-effektivnosti-obucheniya',
    available: true,
  },
  {
    title: 'Разработка программ обучения',
    description: 'Как создать корпоративную программу развития под конкретные задачи и уровень сотрудников.',
    to: '/enciklopediya-korporativnogo-obucheniya/razrabotka-programm-obucheniya',
    available: true,
  },
  {
    title: 'Корпоративная академия',
    description: 'Создание внутренней системы обучения, которая работает на постоянной основе.',
    to: '/enciklopediya-korporativnogo-obucheniya/korporativnaya-akademiya',
    available: true,
  },
  {
    title: 'Тренинг для руководителей',
    description: 'Развитие управленческих компетенций: от постановки задач до управления изменениями.',
    to: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley',
    available: true,
  },
  {
    title: 'Развитие управленческих компетенций',
    description: 'Комплексная оценка и развитие ключевых управленческих навыков руководителей.',
    to: '/menedzhment-i-liderstvo/razvitie-upravlencheskih-kompetenciy',
    available: true,
  },
  {
    title: 'Индивидуальные программы корпоративного обучения',
    description: 'Программа под конкретную категорию сотрудников или задачу компании.',
    available: false,
  },
];

export default function ClusterNavigation() {
  return (
    <section className="py-16 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Развитие персонала: основные направления
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-12 leading-relaxed">
          Развитие сотрудников может решать разные задачи, поэтому компания может выбрать отдельное направление или комплексную программу. Ниже — направления, которые уже доступны на сайте.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {clusterCards.map((card, i) => (
            <div key={i} className={`bg-white rounded-xl border ${card.available ? 'border-gray-200 hover:border-teal-300 hover:shadow-lg' : 'border-gray-200/70'} transition-all p-5 md:p-6 flex flex-col`}>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{card.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4 flex-grow">{card.description}</p>
              {card.available && card.to ? (
                <Link to={card.to} className="inline-flex items-center gap-1.5 text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors cursor-pointer whitespace-nowrap mt-auto">
                  Подробнее
                  <i className="ri-arrow-right-line"></i>
                </Link>
              ) : (
                <span className="inline-flex items-center gap-1.5 text-sm text-gray-400 mt-auto">
                  Скоро
                  <i className="ri-time-line"></i>
                </span>
              )}
            </div>
          ))}
        </div>

        <p className="text-center text-sm md:text-base text-gray-500 mt-8 max-w-3xl mx-auto leading-relaxed">
          Общий обзор форматов и подходов к корпоративному обучению — в разделе{' '}
          <Link to="/enciklopediya-korporativnogo-obucheniya" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">
            «Энциклопедия корпоративного обучения»
          </Link>.
        </p>
      </div>
    </section>
  );
}